import { IDialogAction } from './IDialogAction';
import { DialogState } from '../models/DialogState';

export const FEED_READY = 'FEED_READY';

export class FeedReadyAction implements IDialogAction {
    public readonly type = FEED_READY;
    public constructor(public payload: any) {}
    public reducer(state: DialogState): DialogState {
        state.feed.lastActivityId = this.payload.a;
        state.feed.pageNumber = this.payload.p;
        state.feed.hasMoreMessages = this.payload.m;
        state.feed.messagesReady = true;
        return state;
    }
}

export const FeedReadyActionTypeMapping = {
    [FEED_READY]: FeedReadyAction
};